import { Box, Card, Heading } from '@brand/components';

import { Seo } from '@hoa/atoms';
import { Layout } from '@hoa/layouts';
import { useTranslation } from '@hoa/hooks';
import { GetStaticPaths } from 'next';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { LocalStorage } from '@hoa/config';

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [{ params: { lang: `fr` } }, { params: { lang: `nl` } }],
  fallback: false,
});

export const getStaticProps = async (context: any) => {
  const lang = context.params?.lang;

  return { props: { lang } };
};

export const LogOffPage = () => {
  const { t } = useTranslation();
  const ErrorHeroImage = `${process.env.NEXT_PUBLIC_CDN}/images/hero-images/jaimy-404.jpg`;

  useEffect(() => {
    Cookies.remove(LocalStorage.COOKIE_NAME);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  }, []);

  return (
    <>
      <Seo
        title={t(`category:seo.title`)}
        description={t('category:seo.description')}
        indexed={false}
      />
      <Layout hasHeader hasFooter={'small'} isMenuSticky={false}>
        <Box
          display={'flex'}
          alignItems="center"
          justifyContent={'center'}
          width={'100%'}
          height="100vh"
          backgroundImage={ErrorHeroImage}
        >
          <Card
            display="flex"
            width={'80%'}
            minH="40%"
            flexDirection="column"
            alignItems={'center'}
            justifyContent={'space-around'}
            padding="50px"
            backgroundColor={'hsla(0, 0%, 100%, 0.70)'}
          >
            <Heading variant="h5" marginBottom="25px">
              {t(`error:logoff.title`)}
            </Heading>
          </Card>
        </Box>
      </Layout>
    </>
  );
};
export default LogOffPage;
